import React, { createContext, useContext } from 'react'

const EvalSessionChromeContext = createContext<React.ReactNode>(undefined)

export type EvalSessionChromeProviderProps = {
  headerFilters: React.ReactNode
  children: React.ReactNode
}

export function EvalSessionChromeProvider({
  headerFilters,
  children,
}: EvalSessionChromeProviderProps): React.ReactElement {
  return (
    <EvalSessionChromeContext.Provider value={headerFilters}>
      {children}
    </EvalSessionChromeContext.Provider>
  )
}

export function useEvalSessionHeaderFilters(): React.ReactNode {
  return useContext(EvalSessionChromeContext)
}
